import { Injectable, Injector } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { ResponseEnvelope } from './http.models';
import { ApplicationError } from '../common/error.model';
import { SsoService } from '../sso/sso.service';
import { SsoTokenVO, UserVO } from '../sso/sso.models';

@Injectable()
export class HttpService {

  constructor(private http: Http, private injector: Injector
  ) { }

  public get ssoService(): SsoService { 
    return this.injector.get(SsoService);
  }

  private prepareSuccessResponse(res: Response): ResponseEnvelope {
    let resEnvelope: ResponseEnvelope = null;
    let respJson = res.json() || {};
    if (respJson) {
      resEnvelope = new ResponseEnvelope(respJson);
    } else {
      console.error("Response json couldn't be read. " + respJson);
    }

    return resEnvelope;
  }

  private prepareErrorResponse(error: Response | any): ApplicationError {
    // In a real world app, you might use a remote logging infrastructure
    let errorCode = "UNKNOWN_ERROR";
    let errorMsg = "An unknow error has occurred. Please inform the system administrators."
    if (error instanceof Response) {
      let errorJson = error.json();
      if (errorJson && errorJson.header) {
        errorCode = errorJson.header.statusCode;
        errorMsg = errorJson.header.statusMsg;
      }
    } else {
      let errJson = error.message ? error.message : error.toString();
      console.error("Couldn't parse error message. " + errJson);
    }

    let errResEnvelope: ApplicationError = new ApplicationError(errorCode, errorMsg, error);
    errResEnvelope.httpStatusCode = error.status;

    return errResEnvelope;
  }

  get(url: string, headers?: any): Observable<any> {
    // setInHeader -> appSessionId, authToken, paginationToken
    const options = new RequestOptions({
      withCredentials: true
    });
    if (headers !== undefined && headers.get("Authorization") !== undefined) {
      options.headers = headers;
      return this.http.get(encodeURI(url), options)
        .map(response => {
          return this.prepareSuccessResponse(response);
        })
        .catch(error => {
          let errResponse: ApplicationError = this.prepareErrorResponse(error);
          throw errResponse;
        });
    }
    else {
      return Observable.of(this.ssoService.getToken(true)
      .then(tokenVO => {
         return this.addHeaderAndSendGetRequest(tokenVO, url); 
        },
        error=>{
          console.log("Error receiving Authorization Header");
          throw error;
      }));
    }
  }

  private addHeaderAndSendGetRequest(tokenVO: SsoTokenVO, url: string): Promise<any> {

    let accessToken = tokenVO.getAccessToken();
    let headers = new Headers({
      'Authorization': 'Bearer ' + accessToken,
      'Content-Type': 'application/json'
    });
    return this.get(url, headers).toPromise()
      .then(responseEnvelope => {
        console.log(responseEnvelope);
        return responseEnvelope;
      }
      , error => {
        console.error("Error received in get user details service. " + JSON.stringify(error));
        throw error;
      });
  }

  post(url: string, body: any, headers?: any): Observable<any> {
    const options = new RequestOptions({
      withCredentials: true
    });
    if (headers !== undefined && headers.get("Authorization") !== undefined) {
      options.headers = headers;
      return this.http.post(encodeURI(url), body, options)
        .map(response => { 
          return this.prepareSuccessResponse(response);
        })
        .catch(error => {
          let errResponse: ApplicationError = this.prepareErrorResponse(error);
          throw errResponse;
        });
    }
    else {
      return Observable.of(this.ssoService.getToken(true)
      .then(tokenVO => { 
        return this.addHeaderAndSendPostRequest(tokenVO, body, url); 
      }
      , error => {
        console.error("Error received in get user details service. " + JSON.stringify(error));
        throw error;
      }));
    }
  }

  private addHeaderAndSendPostRequest(tokenVO: SsoTokenVO, body: any, url: string): Promise<any> {

    let accessToken = tokenVO.getAccessToken();
    let headers = new Headers({
      'Authorization': 'Bearer ' + accessToken,
      'Content-Type': 'application/json'
    });
    return this.post(url, body, headers).toPromise()
      .then(responseEnvelope => {
          return responseEnvelope;
      }
      , error => {
        console.error("Error received in reset password service. " + JSON.stringify(error));
        throw error;
      });
  }

  put(url: string, body: any, headers?: any): Observable<any> {
    const options = new RequestOptions({
      withCredentials: true
    });
    if (headers !== undefined && headers.get("Authorization") !== undefined) {
      console.log("Sending request with content : "+body);  
      options.headers = headers;
      return this.http.put(encodeURI(url), body, options)
        .map(response => {
          return this.prepareSuccessResponse(response);
        })
        .catch(error => {
          let errResponse: ApplicationError = this.prepareErrorResponse(error);
          throw errResponse;
        });
    }
    else {
      return Observable.of(this.ssoService.getToken(true)
      .then(tokenVO => {
         return this.addHeaderAndSendPutRequest(tokenVO, body, url); 
        }
      , error => {
        console.error("Error received in get user details service. " + JSON.stringify(error));
        throw error;
      } ));
    }
  }

  private addHeaderAndSendPutRequest(tokenVO: SsoTokenVO, body: any, url: string): Promise<any> {

    let accessToken = tokenVO.getAccessToken();

    let headers = new Headers({
      'Authorization': 'Bearer ' + accessToken,
      'Content-Type': 'application/json'
    });
    return this.put(url, body, headers).toPromise()
      .then(responseEnvelope => {
        return responseEnvelope;
      }
      , error => {
        console.error("Error received in reset password service. " + JSON.stringify(error));
        throw error;
      });
  }

  // delete(zenComponentContext: ZenComponentContext, url: string, body: any, headers: any): Observable<any> {
  //   const options = new RequestOptions({
  //     withCredentials: true
  //   });
  //   if (headers !== undefined) {
  //     options.headers = headers;
  //   }
  //   if (body !== undefined) {
  //     options.body = body;
  //   }
  //   return this.http.delete(url, options).map(this.extractData)
  //     .catch(this.handleError);
  // }

}



// WEBPACK FOOTER //
// ./src/app/http/http.service.ts